module.exports = __webpack_public_path__ + "img/1. start.873bff1c.png";